module.exports = __webpack_public_path__ + "assets/-_15.feabab50.svg";